import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es';
import en from './locales/en';
import pt from './locales/pt';
import fr from './locales/fr';
import de from './locales/de';
import nl from './locales/nl';
import ro from './locales/ro';

// Espacio de nombres `recognition` — textos del Programa de Reconocimiento. Es ADITIVO: el
// espacio `translation` que usa el portal no se toca, así que ninguna pantalla actual cambia.
import recognitionEs from './locales/recognition/es';
import recognitionEn from './locales/recognition/en';
import recognitionPt from './locales/recognition/pt';
import recognitionFr from './locales/recognition/fr';
import recognitionDe from './locales/recognition/de';
import recognitionNl from './locales/recognition/nl';
import recognitionRo from './locales/recognition/ro';

import { SUPPORTED_LANGUAGE_CODES } from './languages';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es, recognition: recognitionEs },
      en: { translation: en, recognition: recognitionEn },
      pt: { translation: pt, recognition: recognitionPt },
      fr: { translation: fr, recognition: recognitionFr },
      de: { translation: de, recognition: recognitionDe },
      nl: { translation: nl, recognition: recognitionNl },
      ro: { translation: ro, recognition: recognitionRo },
    },
    fallbackLng: 'es',
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
